import React from 'react'
import { chooseWallpaper, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import LoaderButton from '../../components/LoaderButton';
import HttpServices from '../../utils/Http.services';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import ShareQrCode from '../../components/share/ShareQrCode';


class CredentialsKey extends React.Component {
    state = {
        pages: [
            { key: 'credentials', label: 'Credentials', icon: '/images/icons/credentials.svg', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
            { key: 'rooms', label: 'Your Rooms', icon: '/assets/icons/fi-sr-info.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
            { key: 'schedule', label: 'Schedule', icon: '/assets/icons/fi-sr-apps.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
            { key: 'history', label: 'History', icon: '/assets/icons/fi-sr-megaphone.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        ],
        currentPage: 'dashboard',

        applet: [
            { name: 'Applet namefdfsdf', icon: '/images/icons/y1.svg' },
            { name: 'Applet namefdfsdf', icon: '/images/icons/y2.svg' },
            { name: 'Applet namefdfsdf', icon: '/images/icons/y3.svg' },
            { name: 'Applet name samkdm ', icon: '/images/icons/y4.svg' },
            { name: 'Applet namefdfsdf', icon: '/images/icons/y5.svg' },
            { name: 'Applet namefdfsdf', icon: '/images/icons/y6.svg' },
            { name: 'Applet namefdfsdf', icon: '/images/icons/y7.svg' },
            { name: 'Applet namefdfsdf', icon: '/images/icons/y8.svg' },
            { name: 'Applet namefdfsdf', icon: '/images/icons/y9.svg' },
            { name: 'Applet namefdfsdf', icon: '/images/icons/y10.svg' },
        ]
    }

    componentDidMount() {

    }

    componentWillUnmount() {
    }


    changePage = (item) => {
        this.setState({ currentPage: item.key })
    }



    render() {
        let applet = this.state.applet;
        return (

            <div className="window-content-radius w-100 flexc flex-column  px-2" style={{backgroundColor:'#f0f0f0',minHeight:this.props.height}}>
                <div className='br-10  mt-4 pb-4' style={{maxWidth:800,backgroundColor:'#fff'}}>
                    <div className='w-100'>
                        <ShareQrCode with={this.props.with} initData={this.props.initData} setData={this.props.setData} data={this.props.data} img={'/images/p7.png'} name={'Applet Name'} des={'Applet short discription'} bgColor={'#f2f2f2'} />
                    </div>
                    {/* <div className='mt-4 d-flex justify-content-end'>
                        <ButtonAnimated icon={'/assets/icons/check-white.svg'} iconwidth={'28px'} bg={'linear-gradient(90deg, #B22626, #DD3A3A)'} title={'Done'} onClick={() => this.props.changePage("Credential")} isLoading={this.state.isLoading} />
                    </div> */}
                </div>
            </div>

        )
    }
}

export default CredentialsKey;